<template>
  <div class="main-wrapper">
    <router-view />
        <FooterBar />
  </div>
</template>

<script>
import FooterBar from "./components/FooterBar.vue";

export default {
  name: "App",
  components: {
    FooterBar
  }
};
</script>

<style lang="scss">
#app {
  /* font-family: Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: $bluegrey;
  color: $darkbrown;
  /* margin-top: 60px; */
  margin: 0;
  padding-bottom: 56px;
  @include Roboto();
  &:after {
    content: "";
    position: fixed;
    top: 0px;
    bottom: 0px;
    right: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    z-index: -1;
    background: $beige;
    /* background: $beige;*/
  }
  .main-wrapper {
    margin: auto;
    width: calc(100vw - 80px);
  }
}
</style>
